var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.isMobile)?_c('MobileProgressBar',{attrs:{"stepCurrent":_vm.stepCurrent,"stepPopulated":_vm.stepPopulated,"steps":_vm.steps}}):_c('DesktopProgressBar',{attrs:{"stepCurrent":_vm.stepCurrent,"stepPopulated":_vm.stepPopulated,"steps":_vm.steps}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }